import { CommonModal } from "components";
import React, { useEffect, useState } from 'react'
import useDocumentTitle from 'hooks/useDocumentTitle';
import '../../pages/WorkShop/workshop.css'
import { listTutorialModule } from "_services";
import Tab from 'components/common/Tab';
import './youtube.css';
import ReactPlayer from "react-player";
import Loading from "pages/Loading";

const DEFAULT_VIDEO_URL = "https://www.youtube.com/watch?v=D0UnqGm_miA";

const groupBy = (array, key) => {
  return array.reduce((acc, item) => {
    const groupKey = item[key];
    if (!acc[groupKey]) acc[groupKey] = [];
    acc[groupKey].push(item);
    return acc;
  }, {});
};

const YoutubeModal = (props) => {
  const { isOpen, closeModal, modalTitle, videosModuleName } = props;

  const [moduleList, setModuleList] = useState([]);
  const [activeTab, setActiveTab] = useState('Hindi');

  const modalProps = {
    ...props,
    onSubmit: () => { },
    footerPart: true,
    hideFooterSumbmitBtn: true,
    hideCompletelyFoolter: true,
  };

  const getTutorialModuleList = async () => {
    try {
      let object = {
        limit: 50,
        type: 1
      }
      const res = await listTutorialModule(object);
      if (res?.responseCode == 200) {
        let single = res?.data?.list?.find((el) => el?.name === videosModuleName)
        let allElement = []
        single?.tutorials?.forEach((el) => {
          allElement.push(...el?.languages)
        })
        const grouped = groupBy(allElement, 'name');
        setModuleList(grouped);

        const firstTab = Object.keys(grouped)[0];
        if (firstTab) setActiveTab(firstTab);
      }
    } catch (error) {
      console.error("Failed to fetch tutorials", error);
    }
  }

  useEffect(() => {
    if (isOpen) {
      getTutorialModuleList();
    }
  }, [isOpen]);

  const videosArray = React.useMemo(() => {
    return moduleList[activeTab] || [];
  }, [moduleList, activeTab]);

  const changeActiveLanguage = (e, item) => {
    e.preventDefault();
    setActiveTab(item)
  }

  return (
    <CommonModal {...modalProps}>
      <div className="youtube_modal_mainBx">
        <ul className={`nav nav-tabs cstNew_tabs youtube_Tabs`} id="addParty" role="tablist">
          {Object.keys(moduleList)?.map((item, indx) => {
            const key = item;
            const isActive = activeTab === item;
            return (
              <li
                className="nav-item _vhlTab_li"
                role="presentation"
                key={key}
              >
                <button
                  className={`nav-link tabCst_btn _vhlTab_lst ${isActive ? "active" : ""}`}
                  type="button"
                  aria-selected={isActive}
                  onClick={(e) => changeActiveLanguage(e, item)}
                >
                  <span className='__mnLab_title'>
                    {item}
                  </span>
                </button>
              </li>
            );
          })}
        </ul>

        <div className={videosArray?.length > 0 ? "videoList_bx mt-3" : "vid_bx mt-3"}>
          {
            videosArray?.length > 0 ?
              videosArray?.map((el, idx) => {
                return (
                  <div className="player-wrapper" key={el?.title + idx} style={{ width: '100%', maxWidth: '450px', height: '255px', borderRadius: '8px', overflow: 'hidden', border: '1px solid #D4D4D4' }}>
                    <ReactPlayer
                      url={el?.url || DEFAULT_VIDEO_URL}
                      className="react-player"
                      playing={false}
                      controls={true}
                      width="100%"
                      height="100%"
                      // light={true}
                    />
                  </div>
                )
              })
              :
              <div className="loading_Sty_cls">
                <Loading />
              </div>
          }
        </div>

      </div>
    </CommonModal>
  );
};

export default YoutubeModal;